import Copy from './src/copy-combined';
export default Copy;